import { useState, useEffect } from 'react';
import Drawer from '@mui/material/Drawer';
import { ReactComponent as DeleteIcon } from '@Assets/delete.svg';
import { ReactComponent as ScheduleIcon } from '@Assets/calendar-rotate.svg';
import { IoClose as Close } from 'react-icons/io5';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import Modal from '@mui/material/Modal';
import LinearProgress from '@mui/material/LinearProgress';
import BorderRedButtonV2 from '@CommonRepresentationalDisplay/Buttons/BorderRedButtonV2';
import BorderBlueButtonV2 from '@CommonRepresentationalDisplay/Buttons/BorderBlueButtonV2';
import BorderWhiteButtonV2 from '@CommonRepresentationalDisplay/Buttons/BorderWhiteButtonV2';
import { useReduxActiveUser } from '@Hooks/reduxActiveUserHook/useReduxActiveUser';
import { useReduxProject } from '@Hooks/reduxProjectHook/useReduxProject';
import FormAgentService from '@Helpers/URLHelpers/KaiziqResolve/FormAgentService';
import ResolveExportJobService from '@Helpers/URLHelpers/KaiziqResolve/ResolveExportJobService';
import ErrorHandler from '@Root/ErrorHandler';
import './ResolveReportExportForm.scss';

export default function ResolveReportExportForm(props) {

    const [cursor, setCursor] = useState('auto');
    const [loading, setLoading] = useState(true);
    const [showDeleteForm, setShowDeleteForm] = useState(false);
    const [, setInternetException] = useState(false);
    const [showResolveExportForm, setShowResolveExportForm] = useState(false);
    const [selectedExportJob, setSelectedExportJob] = useState({});
    const [exportType, setExportType] = useState('daily');
    const [sendEmailList, setSendEmailList] = useState([]);
    const [emailUsersList, setEmailUsersList] = useState([]);
    const [resolveExportList, setResolveExportList] = useState([]);
    let { activeUser, activeUserId } = useReduxActiveUser();
    let { currentProjectId } = useReduxProject();
    const formAgentService = new FormAgentService();
    const resolveExportJobService = new ResolveExportJobService();
    const errorHandler = new ErrorHandler();
    const className = 'resolveReportExportForm';

    useEffect(()=>{
        renderData();
    },[])

    const renderData = async()=> {
        renderResolveExportList();
        renderFormAgentList();
        setLoading(false);
    }

    const renderResolveExportList = async()=> {
        try {
            let response = await resolveExportJobService.getExportListByFormId(props.kaiziqResolveConnection?.id);
            if(response.status < 400) {
                response = JSON.parse(response.body);
                response = response.map((item)=> ({...item, exportDetails: JSON.parse(item.exportDetails)}));
                setResolveExportList(response);
            }
        } catch (err) {
            errorHandler.handleError(err);
        }
    }

    const renderFormAgentList = async() => {
        var loadLoops = 0, loadingError = false, errorException;
        for(loadLoops = 0; loadLoops < 10; loadLoops++) {
            try {
                let formAgentListObj = await formAgentService.getFormAgentUserListByFormId(props.kaiziqResolveConnection?.id);
                formAgentListObj = JSON.parse(formAgentListObj.body)
                let findCurrentUser = formAgentListObj.find((user)=> user.id === activeUserId);
                if(!!findCurrentUser) {
                    setEmailUsersList(formAgentListObj);
                } else {
                    setEmailUsersList([...formAgentListObj, activeUser]);
                }
                loadingError = false;
                break;
            } catch (err) {
                errorHandler.logError('Form Agent List Data', err);
                loadingError = true;
                errorException = err;
            }
        }
        if(loadLoops === 10 && loadingError === true) {
            errorHandler.handleError(errorException);
            setInternetException(true);
            return false;
        }
        return true;
    }

    const handleSubmit = async()=> {
        setCursor('wait');
        try {
            let resolveObj = {
                exportType : exportType,
                projectId : currentProjectId,
                kaiziqResolveConnectionId: props.kaiziqResolveConnection?.id,
                exportDetails: {
                    notifyToEmail: sendEmailList
                }
            }
            let response = await resolveExportJobService.createResolveExportJob(resolveObj);
            if(response.status < 400) {
                response = JSON.parse(response.body);
                response.exportDetails = JSON.parse(response.exportDetails);
                setResolveExportList([...resolveExportList, response]);
            }
            handleAddExportJob();
        } catch (err) {
            errorHandler.handleError(err);
        }
        setCursor('auto');
    }

    const handleDeleteExportJob = async(e, id)=> {
        e.preventDefault();
        setCursor('wait');
        try {
            let bodyObj = {
                id: id,
            }
            let deleteJob = await resolveExportJobService.deleteResolveExportJob(bodyObj);
            if(deleteJob.status < 400) {
                setResolveExportList((prev)=> prev.filter((item)=> item.id !== id));
                setSelectedExportJob({});
                toggleDeleteForm();
            }
        } catch (err) {
            errorHandler.handleError(err);
        }
        setCursor('auto');
    }

    const handleExportType = (e)=> {
        let value = e.target.value;
        setExportType(value);
    }

    const handleSendEmailSelectChange = (e)=> {
        let emailValue = e.target.value;
        let findEmail = sendEmailList.find((item) => item === emailValue);
        if(!!findEmail) return;
        setSendEmailList(prev => [...prev, emailValue]);
    }

    const removeEmail = (emailValue)=> {
        setSendEmailList((prev)=> prev.filter(item=> item !== emailValue));
    }

    const handleAddExportJob = ()=> {
        setShowResolveExportForm(!showResolveExportForm);
    }

    const toggleDeleteForm = ()=> {
        setShowDeleteForm(!showDeleteForm);
    }

    const handleDeleteButton = (selectedItem) => {
        setSelectedExportJob(selectedItem);
        toggleDeleteForm();
    }

    const resolveExportForm = ()=> {
        return (
            <div className={className + '__inner__body__form'}>
                <div className={className + '__inner__body__form__exportType flex-row-center-space-between'}>
                    <div className={className + '__inner__body__exportType__t1'}>
                        Export Reports :
                    </div>
                    <Select
                        sx={{ width: 100 }}
                        value={exportType}
                        onChange={handleExportType}
                        className={className + '__inner__body__form__exportType__select'}>
                            <MenuItem value='daily'> Daily </MenuItem>
                            <MenuItem value='weekly'> Weekly </MenuItem>
                            <MenuItem value='monthly'> Monthly </MenuItem>
                            <MenuItem value='quarterly'> Quarterly </MenuItem>
                    </Select>
                </div>
                <div className={className + '__inner__body__form__exportTo flex-row-center-space-between'}>
                    <div className={className + '__inner__body__form__exportTo__t1'}>
                        Send Reports to :
                    </div>
                    <Select
                        sx={{ width: 200 }}
                        value={sendEmailList}
                        onChange={(e) => handleSendEmailSelectChange(e)}
                        className={className + '__inner__body__form__exportTo__select'}>
                        {
                            emailUsersList.map((userObj, idx) => (
                                <MenuItem key={idx} value={userObj?.email}>
                                    {userObj?.email}
                                </MenuItem>
                            ))
                        }
                    </Select>
                </div>
                <div className={className + '__inner__body__form__emailList flex-row-flex-start-1vw-gap'}>
                    {
                        sendEmailList.map((email)=>
                            <Chip
                                key={email}
                                label={email}
                                onDelete={()=> removeEmail(email)} />
                        )
                    }
                </div>
                <div className={className + '__inner__body__form__button flex-row-flex-start-1vw-gap'} >
                    <BorderWhiteButtonV2
                        text='Cancel'
                        onClick={handleAddExportJob}
                        disabled={cursor === 'wait'}/>
                    <BorderBlueButtonV2
                        disabled={cursor === 'wait' || sendEmailList.length === 0}
                        text='Schedule'
                        onClick={handleSubmit}/>
                </div>
            </div>
        )
    }

    const renderDeleteJobModel = ()=> {
        return (
            <Modal
                open={showDeleteForm}
                onClose={toggleDeleteForm}
                style={{ cursor: cursor }}
                onKeyPress={(e) => {
                    if (e.key === "Enter") {
                        handleDeleteExportJob(e, selectedExportJob?.id);
                    }}}>
                    <div className={className + '__delete'}>
                        <div className={className + '__delete__inner flex-column-flex-start'}>
                            <div className={className + '__delete__inner__titleBar width-wfa'}>
                                <div className={className + '__delete__inner__titleBar__title flex-row-center-0p5rem-gap'}>
                                    <ScheduleIcon className={className + '__delete__inner__titleBar__title__tag'}/>
                                    <div className={className + '__delete__inner__titleBar__title__t1 flex-row-flex-end standard-text-semi-large red-text semi-bold-text'}>
                                        <DeleteIcon className={className + '__inner__titleBar__title__t1__icon'}/>
                                        Delete Job
                                    </div>
                                </div>
                                <Close className={className + '__delete__inner__titleBar__close close-button'} onClick={toggleDeleteForm}/>
                            </div>
                            <div className={className + '__delete__inner__item flex-column-flex-start-2vh-gap'}>
                                <div className={className + '__delete__inner__item__t1 large-text'}>
                                    Export Report {selectedExportJob?.exportType}
                                </div>
                                <div className={className + '__delete__inner__item__emailTo'}>
                                    {
                                        selectedExportJob?.exportDetails?.notifyToEmail?.map((email)=>
                                            <Chip
                                                key={email}
                                                label={email} />
                                        )
                                    }
                                </div>
                            </div>
                            <form className={className + '__delete__inner__form flex-column-flex-start width-wfa'} onSubmit={(e)=> handleDeleteExportJob(e, selectedExportJob?.id)}>
                                <div className={className + '__delete__inner__form__info flex-column-flex-start'}>
                                    <div className={className + '__delete__inner__form__info__t1'}>Are you sure you want to delete this Job?</div>
                                </div>
                                <div className={className + '__delete__inner__form__buttonFlex flex-row-center-1rem-gap width-wfa'}>
                                    <div className={className + '__delete__inner__form__buttonFlex__delete width-wfa'}>
                                        <BorderRedButtonV2
                                            text='Delete'
                                            onClick={(e)=> handleDeleteExportJob(e, selectedExportJob?.id)}
                                            disabled={cursor === 'wait'}/>
                                    </div>
                                    <div className={className + '__delete__inner__form__buttonFlex__cancel width-wfa'}>
                                        <BorderWhiteButtonV2
                                            text='Cancel'
                                            onClick={toggleDeleteForm}
                                            disabled={cursor === 'wait'}/>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
            </Modal>
        )
    }

    return (
        <Drawer onClose={props.closePopup}
            size={'lg'}
            anchor='right'
            open={props.open}
            style={{ cursor: cursor }}>
            <div className={className + ' width-wfa'}>
                {
                    loading ?
                        <LinearProgress className={className + '__loader default-loader'} color="inherit" />
                    :
                        <div className={className + '__inner'}>
                            <div className={className + '__inner__top flex-row-center-space-between'}>
                                <div className={className + '__inner__top__t1 flex-row-center-1vw-gap'}>
                                    <ScheduleIcon className={className + '__inner__top__icon'}/>
                                    Schedule Reports
                                </div>
                                <Close className={className + '__inner__top__close close-button'}
                                    onClick={props.closePopup}/>
                            </div>
                            <div className={className + '__inner__body'}>
                                {
                                    resolveExportList.length === 0 ?
                                        resolveExportForm()
                                    :
                                        <div className={className + '__inner__body__list'}>
                                            {
                                                showResolveExportForm &&
                                                    resolveExportForm()
                                            }
                                            {
                                                resolveExportList.map((item)=>
                                                    <div className={className + '__inner__body__list__item'}>
                                                        <div className={className + '__inner__body__list__item__t1'}>
                                                            Export Report {item?.exportType}
                                                        </div>
                                                        <div className={className + '__inner__body__list__item__emailTo'}>
                                                            {
                                                                item?.exportDetails?.notifyToEmail?.map((email)=>
                                                                    <Chip
                                                                        key={email}
                                                                        label={email} />
                                                                )
                                                            }
                                                        </div>
                                                        <DeleteIcon
                                                            className={className + '__inner__body__list__item__delete small-dashboard-icon'}
                                                            onClick={(e)=> handleDeleteButton(item)}/>
                                                    </div>
                                                )
                                            }
                                        </div>
                                }
                                {
                                    !showResolveExportForm &&
                                        <button className={className + '__inner__body__add'} onClick={handleAddExportJob}>
                                            + Add Jobs
                                        </button>
                                }
                            </div>
                        </div>
                }
                {
                    showDeleteForm &&
                        renderDeleteJobModel()
                }
            </div>
        </Drawer>
    )
}